import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Field } from './PayBits';

export const SCOPES = [['default', 'Everyone (organization default)'], ['sport', 'A sport'], ['event', 'A league / tournament'],
  ['official', 'One official'], ['official_event', 'One official in one league / tournament']];
const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const pickList = (label, value, items, onChange, testId) => (
  <Field label={label}>
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder="Choose…" /></SelectTrigger>
      <SelectContent>{items.map(x => <SelectItem key={x.id} value={x.id}>{x.name}</SelectItem>)}</SelectContent>
    </Select>
  </Field>
);

export const splitPair = (ref) => {
  const [officialId = '', eventId = ''] = (ref || '').split(':');
  return [officialId, eventId];
};

export const RateTarget = ({ d, scope, refId, onPick }) => {
  if (scope === 'default') return null;
  if (scope === 'official_event') {
    const [o, e] = splitPair(refId);
    return (
      <>
        {pickList('Official', o, d.officials, v => onPick(scope, `${v}:${e}`), 'rates-ref-official')}
        {pickList('League / tournament', e, d.events, v => onPick(scope, `${o}:${v}`), 'rates-ref-event')}
      </>
    );
  }
  const items = scope === 'sport' ? d.sports.map(s => ({ id: s, name: cap(s) })) : scope === 'event' ? d.events : d.officials;
  return pickList(SCOPES.find(s => s[0] === scope)[1], refId, items, v => onPick(scope, v), 'rates-ref');
};
